import { CircularProgress } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import image1 from '../../Assets/images/Activation/DEVICE_ICON.svg';
import image2 from '../../Assets/images/Activation/DEVICE_ID.svg';
import Android from '../../Assets/images/Activation/android.svg';
import Apple from '../../Assets/images/Activation/iOSlogo.svg';
// import {  pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';
import { imei } from '../../store/Activation/actions';
import Button from '../Button/Button';
import TextField from '../Textfield/TextField';
import './VerfiyDevice.scss';
import failedIcon from '../../Assets/images/Activation/failed.svg';
import backArrow from '../../Assets/images/PostActivation/Account/backArrow.svg';
import TagManager from 'react-gtm-module';

type initialProps = {
    history: any;
    setIsAddLineSummary?: any;
    setDeviceDetails?: any;
    deviceDetails?: any;
    setIsImeiData: any;
    isImeiData: any;
    isInvalidImei: any;
    setIsInvalidImei: any;
};

const VerifyDevice = (props: initialProps) => {
    const {
        setIsAddLineSummary,
        setDeviceDetails,
        deviceDetails,
        isImeiData,
        setIsImeiData,
        isInvalidImei,
        setIsInvalidImei,
    } = props;
    const { activation } = useSelector((state: any) => state);
    const [imeiNumber, setImeiNumber] = useState<any>('');
    const [imeiErr, setImeiErr] = useState<any>('');
    const [imeiCheckLoader, setImeiCheckLoader] = useState(false);
    const [isCurrentESim, setisCurrentESim] = useState(false);
    const [imeiModel, setImeiModel] = useState<any>('');

    const dispatch = useDispatch();

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current === true) {
            initialRender1.current = false;
        } else {
            const imeiData = activation.imei;
            const imeiDataError = activation.errorImei;
            if (imeiData && imeiData.status === 'SUCCESS' && imeiData.data) {
                setImeiCheckLoader(false);
                if (imeiData.data.isValid) {
                    if (imeiData.data.model) {
                        const data = {
                            esim: imeiData.data.esimAvailable ? imeiData.data.esimAvailable : false,
                            model: imeiData.data.model ? imeiData.data.model : '',
                            make: imeiData.data.make ? imeiData.data.make : '',
                            imei: imeiData.data.imei ? imeiData.data.imei : imeiNumber,
                        };
                        setDeviceDetails(data);
                        setIsImeiData(true);
                        setisCurrentESim(imeiData.data.esimAvailable);
                        setImeiModel(imeiData.data.model);

                        let currentdetails: any = localStorage.getItem('customerDetail');
                        currentdetails = JSON.parse(currentdetails);
                        // let occurence = currentdetails.peerAccountRef.split('|')[2];
                        TagManager.dataLayer({
                            dataLayer: {
                                event: "Check",
                                accountNo: currentdetails?.meta?.customer_statement_number,
                                line_number: currentdetails.additionalLines + 2,
                                Imei: imeiNumber,
                                Imei_compatible_status: imeiData.data.isValid,
                            },
                          });
                        // GAAndFBEventsHandler(
                        //     "Check", 
                        //     currentdetails?.meta?.customer_statement_number, 
                        //     currentdetails.additionalLines + 2, 
                        //     [imeiData.data.isValid, imeiNumber]
                        // )
                    } else {
                        setIsInvalidImei(true);
                    }
                } else {
                    setIsInvalidImei(true);
                }
            }
            if (imeiDataError && imeiDataError.status === 'FAILURE') {
                setImeiCheckLoader(false);
            }
        }
    }, [activation.imei, activation.errorImei]);

    const imeiHandler = (e: any) => {
        // let usedImei: any = localStorage.getItem('usedImeiNos');
        // usedImei = JSON.parse(usedImei);

        setImeiNumber(e.target.value);
        setImeiErr('');
        if(e.target.value.length === 15) {
            let currentdetails: any = localStorage.getItem('customerDetail');
            currentdetails = JSON.parse(currentdetails);
            TagManager.dataLayer({
                dataLayer: {
                    event: "Imei_type",
                    accountNo: currentdetails?.meta?.customer_statement_number,
                    line_number: currentdetails.additionalLines + 2,
                    typed_imei: e.target.value,
                },
              });
            // GAAndFBEventsHandler(
            //     "Imei_type", 
            //     currentdetails?.meta?.customer_statement_number, 
            //     currentdetails.additionalLines + 2, 
            //     e.target.value
            // )
        }
        // if (usedImei.includes(e.target.value)) {
        //     setImeiErr('This device IMEI is already in use.');
        // } else {
        //     setImeiErr('');
        // }
    };
    const checkHandler = async () => {
        if (imeiNumber && imeiErr === '' && imeiNumber.length === 15 && /^\d+$/.test(imeiNumber)) {
            setImeiCheckLoader(true);
            dispatch(
                imei({
                    imei: imeiNumber,
                    countryCode: 'usa',
                }),
            );
        } else {
            if (imeiNumber === '') {
                setImeiErr('Enter Your Device IMEI or MEID Number');
            } else if (imeiNumber !== '' && imeiNumber.length !== 15) {
                setImeiErr('Enter valid IMEI Number');
            } else if (imeiNumber !== '' && !/^\d+$/.test(imeiNumber)) {
                setImeiErr('Please enter only digits');
            }
        }
    };

    const editHandler = () => {
        setIsImeiData(false);
    };
    // const GAAndFBEventsHandler = (buttonVal: string, accNumber?: any, lineNumber?:any, size?:any) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
    //       accNumber: accNumber,
    //       lineNumber: lineNumber,
    //       data: size,
    //     });
    //   };

    const proceedHandler = (simType?: any) => {
        if (simType === 'SIM' && deviceDetails.esim) {
            setDeviceDetails({ ...deviceDetails, esim: false });
        }
        setIsAddLineSummary(true);
        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let occurence: any;
        if(secondaryCustomer) {
            occurence = secondaryCustomer.peerAccountRef.split('|')[2];
        } else {
            occurence = currentdetails.peerAccountRef.split('|')[2];
        }
        TagManager.dataLayer({
            dataLayer: {
                event: simType === 'SIM' ? 'Physical' : 'eSIM',
                accountNo: currentdetails?.meta?.customer_statement_number,
                line_number: occurence,
            },
          });
        // GAAndFBEventsHandler(simType === 'SIM' ? 'Physical' : 'eSIM', currentdetails?.meta?.customer_statement_number, occurence)
    };

    return (
        <div>
            {!isImeiData && !isInvalidImei ? (
                <>
                    <div className="activationBox">
                        <div className="heading">Verify device compatibility:</div>
                        <div className="InputField">
                            <div className="imeiText">Enter Device IMEI number</div>
                            <TextField
                                value={imeiNumber}
                                type="text"
                                // label="Enter Your Device IMEI or MEID Number"
                                onChange={(e: any) => {
                                    if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                        imeiHandler(e);
                                    }
                                }}
                                error={
                                    imeiErr !== '' ||
                                    (imeiNumber !== '' && !/^\d+$/.test(imeiNumber)) ||
                                    (imeiNumber !== '' && imeiNumber.length !== 15) ||
                                    (imeiCheckLoader && imeiNumber === '')
                                    // isIMEIused
                                }
                                helperText={
                                    imeiErr
                                        ? imeiErr
                                        : imeiNumber !== '' && !/^\d+$/.test(imeiNumber)
                                        ? 'Please enter only digits'
                                        : imeiNumber !== '' && imeiNumber.length !== 15
                                        ? 'Enter valid IMEI Number'
                                        : imeiCheckLoader && imeiNumber === ''
                                        ? 'Enter valid IMEI Number'
                                        : // : isIMEIused
                                          //     ? 'This device IMEI is already in use.'
                                          ''
                                }
                                maxlength={15}
                            />

                            <div className="limit-div">
                                {imeiNumber && imeiNumber.length ? imeiNumber.length : '0'}
                                /15
                            </div>
                        </div>
                        <div className="check-button">
                            <Button
                                primary={true}
                                onClick={!imeiCheckLoader ? checkHandler : ()=> {}}
                                disabled={
                                    imeiErr !== '' ||
                                    (imeiNumber !== '' && !/^\d+$/.test(imeiNumber)) ||
                                    (imeiNumber !== '' && imeiNumber.length !== 15) ||
                                    imeiNumber === ''
                                    // isIMEIused
                                }
                            >
                                {imeiCheckLoader ? (
                                    <div className="loaderCheck text-center">
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    'CHECK'
                                )}
                            </Button>
                        </div>

                        <div className="noteText">
                            <span>Note: </span>Make sure your device is unlocked. Your phone should be paid in full and
                            not under contract with another provider.
                        </div>
                        <div className="line"></div>
                    </div>
                    <div className="BottomContent">
                        <div className="innerDivs">
                            <div className="div1">How to find your IMEI number</div>
                            <div className="div2">
                                On most phones, dial *<span>#06#</span>
                            </div>
                        </div>
                        <div className="ImageContent">
                            <div className="media">
                                <div className="picture">
                                    <img width={19} src={Apple} alt="" />
                                </div>
                                <div className="pictureBody">
                                    <div className="text1">iOS</div>
                                    <div className="text2">Go to Settings - General - About - IMEI</div>
                                </div>
                            </div>
                            <div className="media">
                                <div className="picture">
                                    <img width={19} src={Android} alt="" />
                                </div>
                                <div className="pictureBody">
                                    <div className="text1">Android</div>
                                    <div className="text2">Go to Settings - About Phone - Status - IMEI</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : isInvalidImei ? (
                <div className="invalidImeiDiv">
                    <img
                        src={backArrow}
                        alt="backArrow"
                        className="backBtn"
                        onClick={() => {
                            setIsImeiData(false);
                            setIsInvalidImei(false);
                        }}
                    />
                    <img src={failedIcon} alt="successIcon" />
                    <div className="invalidImeiTitle">Invalid IMEI Number</div>
                    <div className="invalidImeiMsg">
                        Please enter a valid IMEI number to check device compatibility.
                    </div>
                    <div className="invalidImeiBtn">
                        <Button
                            primary={true}
                            onClick={() => {
                                setIsImeiData(false);
                                setIsInvalidImei(false);
                            }}
                        >
                            TRY AGAIN
                        </Button>
                    </div>
                </div>
            ) : (
                <div className="activationBox">
                    <div className="heading">
                        {isCurrentESim || deviceDetails?.esim
                            ? 'Congrats! Your device is compatible with Astound Mobile eSIM.'
                            : 'Congrats! Your device is compatible with Astound Mobile.'}
                    </div>
                    <div className="mainContainer">
                        <div className="deviceContainer">
                            <div className="media1">
                                <div className="picture1">
                                    <img width={19} src={image1} alt="" />
                                </div>
                                <div className="pictureBody1">
                                    <div className="text11">Device</div>
                                    <div className="text12">
                                        {imeiModel ? imeiModel : deviceDetails?.model ? deviceDetails?.model : ''}
                                    </div>
                                </div>
                            </div>
                            <div className="media1">
                                <div className="picture1">
                                    <img width={19} src={image2} alt="" />
                                </div>
                                <div className="pictureBody1">
                                    <div className="text11">Device ID (IMEI)</div>
                                    <div className="text12">
                                        {imeiNumber ? imeiNumber : deviceDetails?.imei ? deviceDetails?.imei : ''}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="edit-button" onClick={editHandler}>
                            EDIT DEVICE DETAILS
                        </div>
                    </div>
                    <div className="next-button">
                        {isCurrentESim || deviceDetails?.esim ? (
                            <>
                                <Button primary={true} onClick={() => proceedHandler('ESIM')}>
                                    PROCEED WITH eSIM
                                </Button>
                                <div className="edit-button" onClick={() => proceedHandler('SIM')}>
                                    PROCEED WITH SIM
                                </div>
                            </>
                        ) : (
                            <Button primary={true} onClick={() => proceedHandler('SIM')}>
                                PROCEED
                            </Button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default VerifyDevice;
